/* eslint-disable */
// Do not edit this file, it is auto-generated at build time!
import { Container, MapTo } from '@adobe/aem-react-editable-components';
import '../../libs/aemComponents/Container';
import '../../libs/aemComponents/ExperienceFragment';
import { respGridUtil } from '@marriott/mi-headless-utils';
import { StaticWrapper } from '@marriott/mi-common-static-components';
import {
  EditableHTLWrapper,
  CardHorizontalMini,
  CobrandCardHorizontalFlexible,
  CardHorizontalFeature,
  BannerLayered,
  AccordionContainer,
  AccordionContainerEnhanced,
  CardLayered,
  CardVertical,
  RichText,
  IconBlock,
  VariableColumnContainer,
  NavigationContainerWrapper,
  NavigationUtilityLinkWrapper,
  NavigationWrapper,
  LinkList,
  Footer,
} from '@marriott/mi-common-static-components';
import {
  MerchandisingHeroBanner,
  MerchandisingSmallBanner,
  MerchandisingTileSkinny,
  MerchandisingSerpBannerComp,
  MerchandisingCardTile,
} from '@marriott/mi-merch-components';
import {
  CardFeatures,
  CobrandContainer,
  PointsEarned,
  AwardsGallery,
  CardDetails,
  CobrandTabContainer,
  InternationalPopup,
  PointsDetails,
  StickyCta,
  CobrandCarousel,
  CardOverview,
  AlertBanner,
  CardComparison,
  DataCell,
  TabComponentContainer,
  CobrandWrapper,
  CtaComponent,
} from '@marriott/mi-cobrand-components';
import { HeroBanner } from '@marriott/mi-homepage-components';
const NEXT_PUBLIC_AEM_SITE = process.env.NEXT_PUBLIC_AEM_SITE;

export const AEM_REACT_MAPPING = {
  [`mi-aem-common-spa/components/common/staticwrapper`]: StaticWrapper,
  [`mi-aem-common-spa/components/content/cardhorizontalmini`]: CardHorizontalMini,
  [`mi-aem-common-spa/components/content/cobrandcardhorizontalflexible`]: CobrandCardHorizontalFlexible,
  [`mi-aem-common-spa/components/content/cardhorizontalfeature`]: CardHorizontalFeature,
  [`mi-aem-common-spa/components/content/bannerlayered`]: BannerLayered,
  [`mi-aem-common-spa/components/content/accordioncontainer`]: AccordionContainer,
  [`mi-aem-common-spa/components/content/accordioncontainerenhanced`]: AccordionContainerEnhanced,
  [`mi-aem-common-spa/components/content/iconblock`]: IconBlock,
  [`mi-aem-common-spa/components/content/merchandisingherobanner`]: MerchandisingHeroBanner,
  [`${NEXT_PUBLIC_AEM_SITE}/components/content/awards-gallery`]: AwardsGallery,
  [`${NEXT_PUBLIC_AEM_SITE}/components/content/cardoverview`]: CardOverview,
  [`${NEXT_PUBLIC_AEM_SITE}/components/content/cobrandcontainer`]: CobrandContainer,
  [`${NEXT_PUBLIC_AEM_SITE}/components/content/card-features`]: CardFeatures,
  [`${NEXT_PUBLIC_AEM_SITE}/components/content/pointsdetails`]: PointsDetails,
  [`${NEXT_PUBLIC_AEM_SITE}/components/content/points-section`]: PointsEarned,
  [`${NEXT_PUBLIC_AEM_SITE}/components/content/carddetails`]: CardDetails,
  [`${NEXT_PUBLIC_AEM_SITE}/components/content/stickycta`]: StickyCta,
  [`${NEXT_PUBLIC_AEM_SITE}/components/content/alertbanner`]: AlertBanner,
  [`mi-aem-common-spa/components/content/cardcarouselcontainer`]: CobrandCarousel,
  [`mi-aem-common-spa/components/content/cardlayered`]: CardLayered,
  [`mi-aem-common-spa/components/content/cardvertical`]: CardVertical,
  [`mi-aem-common-spa/components/content/richtext`]: RichText,
  [`${NEXT_PUBLIC_AEM_SITE}/components/content/popup`]: InternationalPopup,
  [`${NEXT_PUBLIC_AEM_SITE}/components/content/cobrandtabcontainer`]: CobrandTabContainer,
  [`${NEXT_PUBLIC_AEM_SITE}/components/content/tabcomponentcontainer`]: TabComponentContainer,
  [`${NEXT_PUBLIC_AEM_SITE}/components/content/card-comparison`]: CardComparison,
  [`mi-aem-common-spa/components/content/linklist`]: LinkList,
  [`mi-aem-common-spa/components/content/variablecolumncontainer`]: VariableColumnContainer,
  [`mi-aem-cobrand/components/content/card-category`]: DataCell,
  [`mi-aem-cobrand/components/content/card-data`]: DataCell,
  [`mi-aem-common-spa/components/experiencefragment`]: Container,
  [`mi-aem-common-spa/components/content/merchandisingsmallbanner`]: MerchandisingSmallBanner,
  [`mi-aem-homepage-spa/components/content/herobanner`]: HeroBanner,
  [`mi-aem-homepage-spa/components/content/universal-footer`]: Footer,
  [`mi-aem-homepage-spa/components/content/global-navigation`]: NavigationContainerWrapper,
  [`mi-aem-homepage-spa/components/content/utilityNavigation`]: NavigationUtilityLinkWrapper,
  [`mi-aem-homepage-spa/components/content/primaryNavigation`]: NavigationWrapper,
  [`mi-aem-common-spa/components/content/tileskinny`]: MerchandisingTileSkinny,
  [`mi-aem-common-spa/components/content/tilesquare`]: MerchandisingCardTile,
  [`mi-aem-common-spa/components/content/serpbanner`]: MerchandisingSerpBannerComp,
  [`${NEXT_PUBLIC_AEM_SITE}/components/content/cobrandwrapper`]: CobrandWrapper,
  [`${NEXT_PUBLIC_AEM_SITE}/components/content/cta-component`]: CtaComponent,
};

export const defineComponentMapping = (
  allowedComponents,
  pagePath,
  isAuthorMode,
  dataLayer,
  columnContainerParams,
  showError,
  resolvedUrl,
  featureTextParams,
  pageFlags,
  isRtl
) => {
  MapTo(`mi-aem-common-spa/components/content/merchandisingsmallbanner`)(
    props => <MerchandisingSmallBanner {...props} isAuthorMode={isAuthorMode} />,
    {
      emptyLabel: 'MerchandesingSmallBanner',
      isEmpty: false,
    }
  );
  MapTo(`mi-aem-common-spa/components/common/staticwrapper`)(StaticWrapper, {
    emptyLabel: 'StaticWrapper',
    isEmpty: false,
  });
  MapTo(`${NEXT_PUBLIC_AEM_SITE}/components/content/cobrandtabcontainer`)(
    props => <CobrandTabContainer {...props} isAuthorMode={isAuthorMode} allowedComponents={allowedComponents} />,
    {
      emptyLabel: 'CobrandTabContainer',
      isEmpty: false,
    }
  );
  MapTo(`${NEXT_PUBLIC_AEM_SITE}/components/content/tabcomponentcontainer`)(
    props => <TabComponentContainer {...props} isAuthorMode={isAuthorMode} allowedComponents={allowedComponents} />,
    {
      emptyLabel: 'TabComponentContainer',
      isEmpty: false,
    }
  );
  MapTo(`${NEXT_PUBLIC_AEM_SITE}/components/content/card-comparison`)(
    props => <CardComparison {...props} isAuthorMode={isAuthorMode} />,
    {
      emptyLabel: 'CardComparison',
      isEmpty: false,
    }
  );
  MapTo(`mi-aem-homepage-spa/components/content/herobanner`)(props => (
    <HeroBanner {...props} isAuthorMode={isAuthorMode} />
  ));
  MapTo(`mi-aem-cobrand/components/content/card-category`)(
    props => <DataCell {...props} isAuthorMode={isAuthorMode} />,
    {
      emptyLabel: 'datacell',
      isEmpty: false,
    }
  );
  MapTo(`mi-aem-cobrand/components/content/card-data`)(props => <DataCell {...props} isAuthorMode={isAuthorMode} />, {
    emptyLabel: 'datacell',
    isEmpty: false,
  });
  MapTo(`mi-aem-common-spa/components/content/cardhorizontalmini`)(
    props => (
      <>
        <CardHorizontalMini {...props} />
      </>
    ),
    {
      emptyLabel: 'CardHorizontalMini',
      isEmpty: false,
    }
  );
  MapTo(`${NEXT_PUBLIC_AEM_SITE}/components/content/cardoverview`)(CardOverview, {
    emptyLabel: 'CardOverview',
    isEmpty: false,
  });
  MapTo(`mi-aem-common-spa/components/content/iconblock`)(IconBlock, {
    emptyLabel: 'IconBlock',
    isEmpty: false,
  });
  MapTo(`mi-aem-common-spa/components/content/merchandisingherobanner`)(
    props => (
      <>
        <MerchandisingHeroBanner {...props} />
      </>
    ),
    {
      emptyLabel: 'MerchandisingHeroBanner',
      isEmpty: false,
    }
  );
  MapTo(`mi-aem-common-spa/components/content/tileskinny`)(MerchandisingTileSkinny, {
    emptyLabel: 'Tile Skinny',
    isEmpty: false,
  });
  MapTo(`mi-aem-common-spa/components/content/tilesquare`)(MerchandisingCardTile, {
    emptyLabel: 'Tile Square',
    isEmpty: false,
  });
  MapTo(`mi-aem-common-spa/components/content/serpbanner`)(MerchandisingSerpBannerComp, {
    emptyLabel: 'SERP Banner',
    isEmpty: false,
  });

  MapTo(`${NEXT_PUBLIC_AEM_SITE}/components/content/awards-gallery`)(AwardsGallery, {
    emptyLabel: 'AwardsGallery',
    isEmpty: false,
  });
  MapTo(`${NEXT_PUBLIC_AEM_SITE}/components/content/points-section`)(PointsEarned, {
    emptyLabel: 'PointsEarned',
    isEmpty: false,
  });
  MapTo(`${NEXT_PUBLIC_AEM_SITE}/components/content/carddetails`)(CardDetails, {
    emptyLabel: 'CardDetails',
    isEmpty: false,
  });
  MapTo(`${NEXT_PUBLIC_AEM_SITE}/components/content/stickycta`)(StickyCta, {
    emptyLabel: 'StickyCta',
    isEmpty: false,
  });
  MapTo(`${NEXT_PUBLIC_AEM_SITE}/components/content/cardcarouselcontainer`)(
    props => <CobrandCarousel {...props} isRtl={isRtl} resolvedUrl={resolvedUrl} />,
    {
      emptyLabel: 'CobrandCarousel',
      isEmpty: false,
    }
  );
  MapTo(`mi-aem-common-spa/components/content/linklist`)(LinkList);
  MapTo(`mi-aem-common-spa/components/content/cardlayered`)(CardLayered, {
    emptyLabel: 'CardLayered',
    isEmpty: false,
  });
  MapTo(`mi-aem-common-spa/components/content/cardvertical`)(CardVertical, {
    emptyLabel: 'CardVertical',
    isEmpty: false,
  });
  MapTo(`${NEXT_PUBLIC_AEM_SITE}/components/content/card-features`)(
    props => <CardFeatures {...props} {...featureTextParams} />,
    {
      emptyLabel: 'CardFeatures',
      isEmpty: false,
    }
  );
  MapTo(`${NEXT_PUBLIC_AEM_SITE}/components/content/pointsdetails`)(PointsDetails, {
    emptyLabel: 'PointsDetails',
    isEmpty: false,
  });
  MapTo(`${NEXT_PUBLIC_AEM_SITE}/components/content/cobrandcontainer`)(
    props => (
      <CobrandContainer
        {...props}
        isAuthorMode={isAuthorMode}
        resolvedUrl={resolvedUrl}
        {...pageFlags}
        {...columnContainerParams}
        allowedComponents={allowedComponents}
      />
    ),
    {
      emptyLabel: 'CobrandContainer',
      isEmpty: false,
    }
  );
  MapTo(`mi-aem-common-spa/components/content/cardcarouselcontainer`)(
    props => (
      <CobrandCarousel
        {...props}
        isAuthorMode={isAuthorMode}
        allowedComponents={allowedComponents}
        {...columnContainerParams}
        isRtl={isRtl}
        resolvedUrl={resolvedUrl}
      />
    ),
    {
      emptyLabel: 'CardCarouselContainer',
      isEmpty: false,
    }
  );
  MapTo(`mi-aem-common-spa/components/content/cobrandcardhorizontalflexible`)(CobrandCardHorizontalFlexible, {
    emptyLabel: 'CobrandCardHorizontalFlexible',
    isEmpty: false,
  });
  MapTo(`mi-aem-common-spa/components/content/cardhorizontalfeature`)(CardHorizontalFeature, {
    emptyLabel: 'CardHorizontalFeature',
    isEmpty: false,
  });
  MapTo(`mi-aem-common-spa/components/content/bannerlayered`)(BannerLayered, {
    emptyLabel: 'BannerLayered',
    isEmpty: false,
  });
  MapTo(`mi-aem-common-spa/components/content/accordioncontainer`)(
    props => <AccordionContainer {...props} isAuthorMode={isAuthorMode} allowedComponents={allowedComponents} />,
    {
      emptyLabel: 'accordioncontainer',
      isEmpty: false,
    }
  );
  MapTo(`mi-aem-common-spa/components/content/accordioncontainerenhanced`)(props => (
    <AccordionContainerEnhanced {...props} isAuthorMode={isAuthorMode} allowedComponents={allowedComponents} />
  ));
  MapTo(`mi-aem-common-spa/components/content/richtext`)(RichText, {
    emptyLabel: 'RichText',
    isEmpty: false,
  });
  MapTo(`${NEXT_PUBLIC_AEM_SITE}/components/content/popup`)(
    props => <InternationalPopup {...props} isAuthorMode={isAuthorMode} allowedComponents={allowedComponents} />,
    {
      emptyLabel: 'popup',
      isEmpty: false,
    }
  );
  MapTo(`mi-aem-common-spa/components/content/variablecolumncontainer`)(
    props => <VariableColumnContainer {...props} isAuthorMode={isAuthorMode} allowedComponents={allowedComponents} />,
    {
      emptyLabel: 'VariableColumnContainer',
      isEmpty: false,
    }
  );
  MapTo(`${NEXT_PUBLIC_AEM_SITE}/components/content/alertbanner`)(
    props => <AlertBanner {...props} isAuthorMode={isAuthorMode} showError={showError} />,
    {
      emptyLabel: 'AlertBanner',
      isEmpty: false,
    }
  );
  MapTo(`mi-aem-homepage-spa/components/content/global-navigation`)(
    props => <NavigationContainerWrapper {...props} isAuthorMode={isAuthorMode} />,
    {
      emptyLabel: 'NavigationContainerWrapper',
      isEmpty: false,
    }
  );
  MapTo(`mi-aem-homepage-spa/components/content/utilityNavigation`)(NavigationUtilityLinkWrapper, {
    emptyLabel: 'NavigationUtilityLinkWrapper',
    isEmpty: false,
  });
  MapTo(`mi-aem-homepage-spa/components/content/primaryNavigation`)(NavigationWrapper, {
    emptyLabel: 'NavigationWrapper',
    isEmpty: false,
  });
  MapTo('mi-aem-homepage-spa/components/content/universal-footer')(Footer, {
    emptyLabel: 'Footer',
    isEmpty: false,
  });
  MapTo(`${NEXT_PUBLIC_AEM_SITE}/components/content/cobrandwrapper`)(
    props => (
      <CobrandWrapper
        {...props}
        isAuthorMode={isAuthorMode}
        {...columnContainerParams}
        allowedComponents={allowedComponents}
        resolvedUrl={resolvedUrl}
      />
    ),
    {
      emptyLabel: 'CobrandWrapper',
      isEmpty: false,
    }
  );
  MapTo(`${NEXT_PUBLIC_AEM_SITE}/components/content/cta-component`)(CtaComponent, {
    emptyLabel: 'CtaComponent',
    isEmpty: false,
  });
  // Temporary workaround due to import issues remove once the platform resolves the import problem

  const ExperienceFragmentVariationConfig = {
    emptyLabel: 'Experience Fragment',

    isEmpty: function (props) {
      return !props || !props.configured;
    },
  };
  MapTo('mi-aem-common-spa/components/experiencefragment')(props => {
    return (
      <Container
        isInEditor
        {...props}
        isPage={false}
        model={respGridUtil(props?.model?.cqItems?.root?.[':items']?.responsivegrid)}
      />
    );
  }, ExperienceFragmentVariationConfig);

  const existingMappings = Object.keys(AEM_REACT_MAPPING);
  if (allowedComponents) {
    allowedComponents.forEach(mapping => {
      const baseModelPath = '/jcr:content/root/responsivegrid/';
      const componentPath = mapping.path.split(baseModelPath)[1];

      if (existingMappings.indexOf(componentPath) === -1) {
        MapTo(componentPath)(EditableHTLWrapper, {
          emptyLabel: mapping.title,
          isEmpty: false,
        });
      } else {
        console.log('mapping exists', componentPath);
      }
    });
  }
};
